import {React,useState,useEffect} from "react";
import { Link } from "react-router-dom";
import  './Resources/Actions.css';


function CustomerList (props){
       
    const[clist, setClist] = useState([]);
    const [inputtext , setInputText] = useState(' ');
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const regx = new RegExp('[^0-9]');
    
    useEffect(()=> {
            
        fetch(API_URL+"api/Customer/CustomerList")
        .then(response => response.json())
        .then(data => {setClist(data)})
        },[]); 

        console.log(clist);

    const customer = clist.filter(el => { 

            if(inputtext ===' ')
            {
              return(el)
            }
            else if (inputtext !== ' ' && regx.test(inputtext))
            {
              return el.CustomerName.toLowerCase().includes(inputtext.toLowerCase())
            }
            else
            {
              return el.CustomerID.toString().includes(inputtext);
                 
            }})
     
        return(
          <>
          <div style={{marginTop:"34px",position:"sticky",top:"38px",width:"100%"}}>
            
          <input id = "search" style={{width:"99%",marginTop:"14px"}} placeholder="Find Customer" onChange = {(e)=>{setInputText(e.target.value)}} className="searchid" autoFocus></input></div><br/>
          {customer.map(cus=>{return(<><Link to ='/actions' style ={{textDecoration:"none"}} state={{cusid:cus.CustomerID, cusname:cus.CustomerName, place:cus.City, custom:cus}}>
          <div className="customerlist" >{cus.CustomerID}. {cus.CustomerName},{cus.City}<br/> <p style={{marginTop:"3px",marginLeft:"30px"}}>{cus.MobileNumber}</p></div></Link><br/></>)})}
         </>
          )
    }
 
export default CustomerList;
